/**
 * MarkdownPreview — the "Rich" view of a fenced ```markdown block inside a
 * RichCodeBlock. Renders the markdown source as rendered prose.
 *
 * Uses the shared <CellCogMarkdown>, but DELIBERATELY passes
 * codeBlockComponent={null} so any nested fenced blocks inside the preview
 * render as a plain <pre><code>. Otherwise we'd nest:
 *   RichCodeBlock → MarkdownPreview → CellCogMarkdown
 *     → RichCodeBlock → MarkdownPreview → CellCogMarkdown → …
 * …infinitely, for any ```markdown block whose content itself includes
 * a fenced block.
 *
 * Does NOT resolve SHOW_FILE / GENERATE_FILE tags — this is a code-preview
 * surface, not a chat surface.
 */
import React from 'react';
import CellCogMarkdown from '../CellCogMarkdown';

/**
 * Strip YAML frontmatter so the leading --- block doesn't get swallowed.
 */
const stripFrontmatter = (text) => {
  if (typeof text !== 'string') return text;
  const match = text.match(/^---\r?\n[\s\S]*?\r?\n---\r?\n/);
  return match ? text.slice(match[0].length) : text;
};

const MarkdownPreview = ({ content, isDarkMode }) => {
  return (
    <div className="rich-code-block-markdown-preview">
      <CellCogMarkdown
        content={stripFrontmatter(content || '')}
        isDarkMode={isDarkMode}
        enableCellCogTags="none"
        codeBlockComponent={null}
        richCodeDefaultMode="raw"
      />
    </div>
  );
};

export default MarkdownPreview;
